import React, { useEffect, useState } from 'react';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { Link } from 'react-router-dom';
import ReactLoading from 'react-loading';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { setsessionuser, getsessionuser } from './../Utils/sessions';
import axios from "axios";
import { Googleloginurl, Loginurl } from './../Utils/urls';
import { useNavigate } from 'react-router-dom';
import { primarycolor } from '../Utils/colors';
import SignUp from './register';
import Resetpassword from './resetpass';
import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';


let color = "white";
let type = "spokes";

function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link color="inherit" to="/nav/terms">
        Eazistey   All Rights Reserved.
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const theme = createTheme();

export default function SignIn({ onsuccesslogin }) {
  const sessionuser = getsessionuser();
  const navigate = useNavigate();
  const [displayusersidenav, setdisplayusersidenav] = useState(false);

  const [user, setuser] = useState(sessionuser);
  const [checked, setChecked] = React.useState(true);
  const [progress, setprogress] = useState(false);
  const [error, seterror] = useState('');
  const [showPassword, setshowPassword] = useState(false);


  const [showsignup, setshowsignup] = useState(false);
  const [showresetpass, setshowresetpass] = useState(false);
  const [showlogin, setshowlogin] = useState(true);

  const [userInfo, setUserInfo] = useState([]);
  const [profileInfo, setProfileInfo] = useState([]);


  useEffect(
    () => {
      if (userInfo) {
        axios
          .get(`https://www.googleapis.com/oauth2/v1/userinfo?access_token=${userInfo.access_token}`, {
            headers: {
              Authorization: `Bearer ${userInfo.access_token}`,
              Accept: 'application/json'
            }
          })
          .then((response) => {
            handlegooglelogin(response.data.email, response.data.username)
            setProfileInfo(response.data);
          })
          .catch((error) => console.log(error));
      }
    },
    [userInfo]
  )

  //handle googke login 
  const handlegooglelogin = (email, username) => {
    if (email) {
      setprogress(true)
      seterror(null)
      axios.post(Googleloginurl, {
        username: email
      }).then(response => {
        setprogress(false)
        if (!response.data.message) {
          setsessionuser(response.data)
          // window.location.replace('/fetchhouses')
          onsuccesslogin()

        } else {
          seterror(response.data.message)
        }
        // 
      }).catch(error => {
        setprogress(false)
        seterror("Sorry an error occurred,try again later");
      });
    }
  }


  const handleSubmit = (event) => {
    seterror(null)
    setprogress(true)
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    const email = data.get('email')
    const password = data.get('password')

    if (!email || !password) {
      seterror("fill all fields")
      setprogress(false)
    } else {
      seterror(null)
      axios.post(Loginurl, {
        username: email,
        password: password
      }).then(response => {
        setprogress(false)
        if (!response.data.error) {
          setsessionuser(response.data)
          onsuccesslogin()

        } else {
          seterror(response.data.message)
        }
        // 
      }).catch(error => {
        setprogress(false)
        seterror("Sorry an error occurred,try again later");
      });
    }
  };


  const login = useGoogleLogin({
    onSuccess: (response) => setUserInfo(response),
    onError: (error) => console.log(`Login Failed: ${error}`,)
  });



  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  //on cancel sign up
  const oncancelsignup = () => {
    setshowsignup(false)
    setshowresetpass(false)
    setshowlogin(true)
  }



  return (
    <Container component="main" maxWidth="xs" style={{ backgroundColor: "white", borderRadius: 20 }}>
      <CssBaseline />
      {showsignup && <SignUp successsignup={onsuccesslogin} cancelsignup={oncancelsignup} />}
      {showresetpass && <Resetpassword successsignup={onsuccesslogin} cancelsignup={oncancelsignup} />}
      {showlogin &&
        <Box
          sx={{
            marginTop: 8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Avatar sx={{ m: 1, bgcolor: primarycolor }}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign in
          </Typography>
          <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="email"
              label="Email Address"
              name="email"
              autoComplete="email"
              autoFocus
            />
            <FormControl fullWidth variant="outlined" sx={{ marginTop: 2 }}>
              <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
              <OutlinedInput
                id="password"
                name="password"
                fullWidth
                autoComplete="current-password"
                type={showPassword ? 'text' : 'password'}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={() => setshowPassword(!showPassword)}
                      edge="end"
                    >
                      {!showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                }
                label="Password"
              />
            </FormControl>
            <FormControlLabel
              control={<Checkbox onChange={handleChange} value="remember" color="primary" />}
              label="Remember me"
            />
            {error && <div style={{ color: "red", fontSize: 10 }}>{error}</div>}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
            >
              {progress ? <ReactLoading type={type} color={color} height={25} width={20} /> : "Sign In"}
            </Button>
            <Grid container>
              <Grid item xs>
                <Link to="" onClick={() => {
                  setshowlogin(false)
                  setshowsignup(false)
                  setshowresetpass(true)
                }} style={{ color: primarycolor, fontSize: 13 }} variant="body2">
                  Forgot password?
                </Link>
              </Grid>
              <Grid item>
                <Link to="" onClick={() => {
                  setshowlogin(false)
                  setshowsignup(true)
                  setshowresetpass(false)
                }} style={{ color: primarycolor, fontSize: 13 }} variant="body2">
                  {"Don't have an account? Sign Up"}
                </Link>
              </Grid>
            </Grid>
            <p align="middle">
              <img style={{ cursor: "pointer", height: 50 }} src={require('./../../assets/common/google.png')} onClick={() => login()} />
            </p>
          </Box>
        </Box>}
      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Container>


  );
}